<app-header></app-header>

<div class="row h100 exhibitor-backoffice">
  <div class="col-12 col-lg-2 h100 exhibitor-backoffice__left">
    <app-menu-exhibitor [active]="'exhibitors'"></app-menu-exhibitor>
  </div>
  <div class="col-12 col-lg-10 exhibitor-backoffice__right">

    <app-menu-exhibitor-sub-menu [active]="'detail-admin'" [exhibitor]="profile"></app-menu-exhibitor-sub-menu>
    
    <div class="exhibitor-backoffice__content" *ngIf="loader.count === 0">

      <div class="action-buttons-container">
        <button type="button" (click)="importExhibitor()" [hidden]="importData.length <= 0" class="btn btn-import" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.IMPORT_EXHIBITOR_ADMIN' | translate }}</button>
        <button type="button" (click)="goTo(buttonLink)"class="btn" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.EDIT_EXHIBITOR_ADMIN' | translate }}</button>
      </div>

      <dl class="row">

        <h3>{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.GENERAL' | translate }}</h3>
        <dt class="col-sm-3">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.STAND' | translate }}</dt>
        <dd class="col-sm-8"><app-stand-display [standData]="profile['standLocation']"></app-stand-display></dd>

        <dt class="col-sm-3">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.CATALOGUE_PLAN' | translate }}</dt>
        <dd class="col-sm-8">{{ getCataloguePlanData(profile['planId']) }}</dd>

        <dt class="col-sm-3">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.STATUS' | translate }}</dt>
        <dd class="col-sm-8">{{ getStatusData(profile['statusId']) }}</dd>

        <dt class="col-sm-3">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.PUBLISHED' | translate }}</dt>
        <dd class="col-sm-8">{{ 'COMMON.' + profile['published'].toString().toUpperCase() | translate }}</dd>

        <dt class="col-sm-3">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.ALLOW_EXHIBITOR_COPY' | translate }}</dt>
        <dd class="col-sm-8">{{ 'COMMON.' + profile['copyAllowed'].toString().toUpperCase() | translate }}</dd>

        <dt class="col-sm-3">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.FORCE_VISIBILITY' | translate }}</dt>
        <dd class="col-sm-8">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.FORCE_VISIBILITY_' + profile['businessVisibility'].toString().toUpperCase() | translate }}</dd>

        <dt class="col-sm-3">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.MAX_NUMBER_OF_NOVELTIES' | translate }}</dt>
        <dd class="col-sm-8">{{ profile['businessNoveltiesLimit'] }}</dd>
      </dl>

      <h3>{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.CONTACT_INFO' | translate }}</h3>
      <dl class="row">
        <dt class="col-sm-2">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.CONTACT_INFO_NAME' | translate }}</dt>
        <dd class="col-sm-9">{{ profile['contactInfo']['contactName'] }}</dd>

        <dt class="col-sm-2">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.CONTACT_INFO_TELEPHONE' | translate }}</dt>
        <dd class="col-sm-9">{{ profile['contactInfo']['contactTelephone'] }}</dd>

        <dt class="col-sm-2">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.CONTACT_INFO_EMAIL' | translate }}</dt>
        <dd class="col-sm-9">{{ profile['contactInfo']['contactEmail'] }}</dd>

        <dt class="col-sm-2">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.CONTACT_INFO_ADDRESS' | translate }}</dt>
        <dd class="col-sm-9">{{ profile['contactInfo']['contactPost'] }}</dd>

        <dt class="col-sm-2">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.CONTACT_INFO_LIMIT' | translate }}</dt>
        <dd class="col-sm-9">{{ 'COMMON.' + profile['lockedByCreditLimit'].toString().toUpperCase() | translate }}</dd>
      </dl>

      <h3>{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.PERFORMANCE' | translate }}</h3>
      <dl class="row">
        <dt class="col-sm-2">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.PERFORMANCE_COMPLETED_EXHIBITOR' | translate }}</dt>
        <dd class="col-sm-4">{{ 'COMMON.' + profile['statistics']['sheetCompleted'].toString().toUpperCase() | translate }}</dd>

        <dt class="col-sm-3">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.PERFORMANCE_EXHIBITOR_CATEGORIES' | translate }}</dt>
        <dd class="col-sm-2">{{ 'COMMON.' + profile['statistics']['exhibitorHierarchicalCategories'].toString().toUpperCase() | translate }}</dd>

        <dt class="col-sm-2">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.PERFORMANCE_SECTOR' | translate }}</dt>
        <dd class="col-sm-4">{{ 'COMMON.' + profile['statistics']['sector'].toString().toUpperCase() | translate }}</dd>

        <dt class="col-sm-3">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.PERFORMANCE_EXHIBITOR_PROPERTIES' | translate }}</dt>
        <dd class="col-sm-2">{{ 'COMMON.' + profile['statistics']['exhibitorCategories'].toString().toUpperCase() | translate }}</dd>

        <dt class="col-sm-2">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.PERFORMANCE_COUNTRY' | translate }}</dt>
        <dd class="col-sm-4">{{ 'COMMON.' + profile['statistics']['country'].toString().toUpperCase() | translate }}</dd>

        <dt class="col-sm-3">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.PERFORMANCE_PRODUCT_CATEGORIES' | translate }}</dt>
        <dd class="col-sm-2">{{ 'COMMON.' + profile['statistics']['productHierarchicalCategories'].toString().toUpperCase() | translate }}</dd>

        <dt class="col-sm-2">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.PERFORMANCE_DESCRIPTION' | translate }}</dt>
        <dd class="col-sm-4">{{ 'COMMON.' + profile['statistics']['description'].toString().toUpperCase() | translate }}</dd>

        <dt class="col-sm-3">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.PERFORMANCE_PRODUCT_PROPERTIES' | translate }}</dt>
        <dd class="col-sm-2">{{ 'COMMON.' + profile['statistics']['productCategories'].toString().toUpperCase() | translate }}</dd>
      </dl>

      <h3>{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.STATS' | translate }}</h3>
      <dl class="row">
        <dt class="col-sm-3">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.STATS_VISITS' | translate }}</dt>
        <dd class="col-sm-8">{{ profile['statistics']['backofficeAccesses'] }}</dd>

        <dt class="col-sm-3">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.STATS_PRODUCT_DETAIL' | translate }}</dt>
        <dd class="col-sm-8">{{ profile['statistics']['productAccesses'] }}</dd>

        <dt class="col-sm-3">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.STATS_LAST_BACKOFFICE_ACCESS' | translate }}</dt>
        <dd class="col-sm-8">{{ profile['lastVisit'] |  date: 'dd-MM-yyyy' }}</dd>
      </dl>

      <h3>{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.SAP' | translate }}</h3>
      <dl class="row">
        <dt class="col-sm-2">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.SAP_ID' | translate }}</dt>
        <dd class="col-sm-9">{{ profile['sapInfo']['id'] }}</dd>

        <dt class="col-sm-2">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.SAP_ORDER_ID' | translate }}</dt>
        <dd class="col-sm-9">{{ profile['sapInfo']['orderId'] }}</dd>

        <dt class="col-sm-2">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.SAP_EMAIL' | translate }}</dt>
        <dd class="col-sm-9">{{ profile['sapInfo']['email'] }}</dd>
      </dl>

      <h3>{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.USER_DETAIL' | translate }}</h3>
      <dl class="row">
        <dt class="col-sm-2">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.USER_DETAIL_LOGIN' | translate }}</dt>
        <dd class="col-sm-9">{{ profile['catalogueUserName'] }}<button class="btn btn--light mx-3" (click)="openModalExhibitorPasswordRecovery()"
          type="button">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.SEND_PASSWORD_RECOVERY' | translate }}</button></dd>
      </dl>


    </div>


  </div>
</div>

<app-footer></app-footer>
